<template>
  <div>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar">
        <div :class="`vx-row pb-4 ${filtroAvancado ? 'sm:mb-0' : 'sm:mb-4'}`">
          <!-- Nome Segurado -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Nome Segurado</span>
            <vs-input
              class="w-full"
              name="Nome"
              id="Nome"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <!-- CPF/CNPJ -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>CPF/CNPJ</span>
            <vs-input
              class="w-full"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
            />
          </div>

          <!-- Placa -->
          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Placa</span>
            <vs-input
              data-testId="license-plate-input"
              v-mask="'AAA-#XX#'"
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
            />
          </div>

          <div :class="`vx-col sm:w-1/6 w-full mt-3`">
            <vs-tooltip
              text="Apólices com pontos: insira os 6 últimos números. Apólices sem pontos: insira o número completo."
            >
              <span>
                Nº da Apólice
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-help-circle"
                ></vs-icon>
              </span>
              <vs-input
                class="w-full"
                v-mask="'#############'"
                name="policy_number"
                id="policy_number"
                v-model="formFiltro.numero_apolice"
                data-testId="policy_number_filter"
              />
            </vs-tooltip>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Status da Apólice</span>
            <v-select
              data-testId="policy-status-select"
              :options="policyStatusOptions"
              multiple
              name="Status da Apólice"
              id="Status da Apólice"
              label="label"
              v-model="formFiltro.status_apolice"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Tipo Apólice</span>
            <v-select
              :options="listApolices"
              multiple
              name="Tipo de Apólice"
              id="Tipo de Apólice"
              v-model="formFiltro.idTipoApolices"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Forma de Pagamento</span>
            <v-select
              :options="paymentMethodOptions"
              multiple
              v-model="formFiltro.id_tipo_pagamento"
              data-testId="payment-method-select"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <!-- Dia de Vencimento           -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Dia de Vencimento</span>
            <vs-input
              class="w-full"
              name="Dia de Vencimento"
              id="Dia de Vencimento"
              v-model="formFiltro.diaVencimento"
            />
          </div>

          <!-- Código -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Nº do Segurado</span>
            <vs-input
              class="w-full"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProspect"
            />
          </div>
          <!-- Chassi -->
          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="Chassi"
              id="Chassi"
              v-model="formFiltro.chassi"
            />
          </div>

          <!-- Regional -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Corretora</span>
            <PermissionedAutocomplete
              source="broker"
              permission-subject="Associados"
              name="Corretora"
              id="Corretora"
              v-model="formFiltro.regional"
            />
          </div>

          <!-- Consultor -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Usuário</span>
            <PermissionedAutocomplete
              source="user"
              permission-subject="Associados"
              name="Consultor"
              id="Consultor"
              v-model="formFiltro.consultor"
            />
          </div>
        </div>

        <div v-if="filtroAvancado" class="vx-row mb-8">
          <!-- Status -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Status</span>
            <v-select
              :options="sortedStatus"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
            ></v-select>
          </div>

          <!-- Estado -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Estado</span>
            <v-select
              :options="estados"
              name="Estado"
              id="Estado"
              v-model="formFiltro.estado"
              @selected="buscaDadosSelectsCidades"
            ></v-select>
          </div>

          <!-- Cidade -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Cidade</span>
            <v-select
              :options="cidades"
              name="Cidade"
              id="Cidade"
              multiple
              v-model="formFiltro.cidade"
            ></v-select>
          </div>

          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Identificador de pagamento</span>
            <vs-input
              class="w-full"
              name="Identificador de pagamento"
              id="Identificador de pagamento"
              v-model="formFiltro.paymentCode"
            />
          </div>

          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Linha digitável</span>
            <vs-input
              class="w-full"
              name="Linha digitável"
              id="Linha digitável"
              v-model="formFiltro.digitableLine"
            />
          </div>

          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>CI</span>
            <vs-input
              class="w-full"
              name="CI"
              id="CI"
              v-model="formFiltro.ci"
            />
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            v-if="b2c == false"
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            v-if="b2c == false"
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';
import { INSURED_STATUS } from '@/constants/insuredStatus';
import { POLICY_STATUSES } from '@/utils/constants';
import autoApi from '@/services/auto.api';
import PermissionedAutocomplete from '@/components/filtros/PermissionedAutocomplete.vue';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    'formFiltro.estado'(value) {
      this.formFiltro.cidade = null;
      if (value) {
        this.buscaDadosSelectsCidades(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      } else {
        this.cidades = [];
      }
    },
  },
  computed: {
    policyStatusOptions() {
      return Object.keys(POLICY_STATUSES)
        .map((key) => {
          return {
            id: POLICY_STATUSES[key].id,
            label: POLICY_STATUSES[key].name,
          };
        })
        .filter((status) => status.id !== POLICY_STATUSES.OPEN.id);
    },
    sortedStatus() {
      return [...this.status].sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      regionalDefault: [],
      regionaisUsuario: [],
      cidades: [],
      usuarios_regionais: [],
      status: INSURED_STATUS,
      languages: lang,
      filtroAvancado: false,
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tiposDatas: ['Data Cadastro', 'Data Vistoria'],
      listaSimNao: ['Sim', 'Não'],
      funcoesValicao: null,
      idTipoApolices: null,
      listApolices: [],
      formFiltro: this.getDefaultFormFiltro(),
      paymentMethodOptions: [],
    };
  },
  methods: {
    getDefaultFormFiltro() {
      return {
        idEmpresa: null,
        cpfCnpj: '',
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        cidade: null,
        estado: null,
        idProspect: null,
        diaVencimento: null,
        placa: null,
        chassi: null,
        idTipoApolices: null,
        status_apolice: [],
        numero_apolice: null,
        id_tipo_pagamento: [],
        paymentCode: null,
        digitableLine: null,
        ci: null,
      };
    },
    limparFiltro() {
      this.formFiltro = this.getDefaultFormFiltro();
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    async buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        this.filtroAvancado = true;
        this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');

        return;
      }
      this.filtroAvancado = false;
    },
    getPaymentMethods() {
      autoApi.getPaymentMethods().then((res) => {
        this.paymentMethodOptions = res.map((item) => ({
          id: item.id,
          label: item.paymentName,
        }));
      });
    },
    buscar() {
      this.$emit('filtro', this.formFiltro);
    },
  },
  mounted() {
    this.getDecoded();
    this.getPaymentMethods();
    this.buscaDadosSelects(
      'tipoApolices',
      'listApolices',
      'nome',
      'tipoApoliceId',
    );
  },
  components: {
    'v-select': vSelect,
    PermissionedAutocomplete,
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
